var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup167(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 64,
    viewBox: "0 0 55 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70194 36.351C10.8991 36.2943 11.9421 36.4118 13.2383 36.6465M35.5076 48.6654C35.3263 45.108 34.1954 43.3688 31.3836 42.534M18.187 46.0453L39.2191 49.1894L41.4873 47.0879M8.70194 56.0016C13.3323 59.1449 20.6614 62.0278 22.9295 62.0278C25.1977 62.0278 33.8497 60.0259 40.6625 57.8357C40.6625 57.8357 51.1786 46.8313 52.8282 43.9492C54.4778 41.0671 51.8424 37.7743 49.1166 40.0191L41.4873 47.0879M13.2383 24.8226V36.6465M13.2383 36.6465C18.782 37.65 17.6423 40.7977 23.1357 41.6436M23.1357 41.6436C23.9413 41.7677 24.8896 41.8422 26.0225 41.8532C28.2606 41.9369 30.0198 42.1291 31.3836 42.534M23.1357 41.6436V28.7527H31.3836V42.534M41.4873 24.8226V47.0879M13.2383 17.7963C10.0827 21.4008 7.42068 24.4447 6.63995 25.3466C4.37184 27.9667 7.05236 31.8968 9.93911 28.7527L27.0535 7.79202C27.0535 7.79202 42.1059 25.6086 44.7865 28.7527C47.467 31.8968 48.9104 26.9187 47.467 25.3466C46.0236 23.7746 27.0535 2.02783 27.0535 2.02783C27.0535 2.02783 23.3104 6.29762 19.0118 11.2041M13.2383 17.7963L13.2383 7.53002H19.0118V11.2041M13.2383 17.7963C15.0864 15.6852 17.1038 13.382 19.0118 11.2041",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66016,
    y: 32.1108,
    width: 6.2479,
    height: 27.869,
    rx: 3.12395,
    stroke: "#006D77",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup167);
export default __webpack_public_path__ + "static/media/Group 167.85638a3c978533603656604a43c8cc1f.svg";
export { ForwardRef as ReactComponent };